import { AreaType, Project } from 'models/project'
import { isEmpty, isNil } from 'ramda'
import distance from '@turf/distance'
import centroid from '@turf/centroid'
import point from 'turf-point'

export const getAreaIcon = (areaType: AreaType) => {
  switch (areaType) {
    case AreaType.ISOCHRONE_CAR:
    case AreaType.ISOCHRONE_CAR_NO_TRAFFIC:
      return 'map-pin-line'

    case AreaType.ISOCHRONE_WALK:
    case AreaType.ISOCHRONE_WALK_NO_TRAFFIC:
      return 'map-pin-line'

    case AreaType.ISOCHRONE_BIKE:
    case AreaType.ISOCHRONE_BIKE_NO_TRAFFIC:
      return 'map-pin-line'


    case AreaType.ISOCHRONE_PUBLICTRANSPORT:
    case AreaType.ISOCHRONE_PUBLICTRANSPORT_NO_TRAFFIC:
      return 'map-pin-line'

    case AreaType.POLYGON:
    case AreaType.FILE:
      return 'shape-fill'

    case AreaType.RADIUS:
      return 'compass-2-line'

    case AreaType.REGION:
      return 'globe-line'
  }
}

export const getAreaDetails = (project: Project) => {
  let text = ''
  let measure

  switch (project.areaType) {
    case AreaType.ISOCHRONE_CAR:
    case AreaType.ISOCHRONE_CAR_NO_TRAFFIC:
      text = 'project.area.car'
      measure = project.time
      break

    case AreaType.ISOCHRONE_WALK:
    case AreaType.ISOCHRONE_WALK_NO_TRAFFIC:
      text = 'project.area.walk'
      measure = project.time
      break

    case AreaType.ISOCHRONE_BIKE:
    case AreaType.ISOCHRONE_BIKE_NO_TRAFFIC:
      text = 'project.area.bike'
      measure = project.time
      break


    case AreaType.ISOCHRONE_PUBLICTRANSPORT:
    case AreaType.ISOCHRONE_PUBLICTRANSPORT_NO_TRAFFIC:
      text = 'project.area.ptransport'
      measure = project.time
      break

    case AreaType.POLYGON:
    case AreaType.FILE:
      text = 'project.area.polygon'
      break

    case AreaType.RADIUS:
      text = 'project.area.radius'
      measure = project.radius
      break

    case AreaType.REGION:
      text = ''
      measure = [project.city, project.municipality, project.state, project.country]
        .filter((region) => !isEmpty(region) && !isNil(region) && region !== '-')
        .join(', ')
      break
  }

  return { iconName: getAreaIcon(project.areaType), text, measure }
}

export const getCircleData = (feature: any) => {
  if (!feature) return { radius: 0 }

  const circleCenter = centroid(feature)
  const radius = distance(
    point(circleCenter?.geometry?.coordinates!),
    point(feature.geometry.coordinates[0][0]),
    {
      units: 'meters',
    },
  )

  return {
    circleCenter: circleCenter.geometry?.coordinates,
    radius,
  }
}
